import adserver from 'services/adserver';
import { productsKeys } from './products.keys';
import { ProductParams } from './products.types';
import { useQuery, useQueries, UseQueryResult } from '@tanstack/react-query';
import { normalizeApiResponse } from './products.helpers';

const getProductById = async (id: number | string): Promise<ProductParams> => {
  const { data } = await adserver({
    url: `/product/${id}`,
    headers: {},
  });
  const normalized = normalizeApiResponse(data);
  if (!normalized) {
    throw new Error('Empty product response');
  }

  return normalized as ProductParams;
};

export const useGetProductById = <TData = ProductParams, TError = Error>(
  id: number | string,
  select?: (data: ProductParams) => TData,
): UseQueryResult<TData, TError> => {
  return useQuery<ProductParams, TError, TData>({
    queryKey: productsKeys.detail(Number(id)),
    queryFn: () => getProductById(Number(id)),
    enabled: !!id,
    select,
  });
};

export const useGetProductsByIds = (
  ids: (number | string)[],
): ReturnType<typeof useQueries> => {
  return useQueries({
    queries: (ids || []).map(id => ({
      queryKey: productsKeys.detail(Number(id)),
      queryFn: () => getProductById(Number(id)),
      enabled: !!id,
      staleTime: 5 * 60 * 1000,
    })),
  });
};
